import { HintTooltip } from "@brg/ui";
import { LayoutConst } from "core";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { NavbarSearchActions, NavbarSearchSelector } from "shared/reducers/NavbarSearch";
import styled from "styled-components"
import { AppTester } from "supporting";


const ButtonWrapper = styled.div<{isKiiidsArt?: boolean, active?: boolean, buttonSize?: number | string }>`
display: flex;
cursor: pointer;
// opacity: 0.47;
// transition: opacity 0.2s;
align-items: center;
position: relative;
// ${p => p.isKiiidsArt && 'margin-right: 24px;' }
 & > div > div:last-child {
    top: 40px;
   @media (max-width: ${LayoutConst.screen.l_16}px) {
      top: 35px;
    })
  }
.main-search-icon {
  path, rect {
    fill: ${(p) => p?.active ? p.theme.navigationBar.search.svgHover : p.theme.navigationBar.search.svg} !important;
  }
}
&:hover {
  .main-search-icon {
    path, rect {
      fill: ${(p) => p.theme.navigationBar.search.svgHover} !important;
    }
  }
}

.main-search-icon {
  width: ${p => p.buttonSize || 24}px !important;
  height: ${p => p.buttonSize || 24}px !important;
}


`;
const Search24 = (p: any = {}) =>
    <svg className="main-search-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...p}>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M9.5 15.5C12.8137 15.5 15.5 12.8137 15.5 9.5C15.5 6.18629 12.8137 3.5 9.5 3.5C6.18629 3.5 3.5 6.18629 3.5 9.5C3.5 12.8137 6.18629 15.5 9.5 15.5ZM9.5 17C13.6421 17 17 13.6421 17 9.5C17 5.35786 13.6421 2 9.5 2C5.35786 2 2 5.35786 2 9.5C2 13.6421 5.35786 17 9.5 17Z"
              fill="#FEFEFE"/>
        <rect x="13.2676" y="14.6821" width="2" height="10.621" rx="1" transform="rotate(-45 13.2676 14.6821)"
              fill="#FEFEFE"/>
    </svg>

export const MainSearchButton = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isOpen = useSelector(NavbarSearchSelector).open;
    const isGeo = AppTester.isGeograffee();
    const isCGRAVE = AppTester.isCGRAVE();
    const isAdcrDafesNet = AppTester.isAdcrDafesNet();
    const isContinuumSite = AppTester.isContinuumSite();
    const isHSEDesign = AppTester.isHSEDesign();
    const isGeoDafes = AppTester.isGeoDafes();
    const isSuperpuper = AppTester.isSuperPuper();
    const isGameDeziiign = AppTester.isGameDeziiign();
    const isGreenAward = AppTester.isGreenAward();
    const isKiiidsArt = AppTester.isKiiidsArt();
    const isLMS = AppTester.isLMSHSE() || AppTester.isLMSHSECreative();

    const onWhiteBg = !isGeo && !isSuperpuper;

    const baseStyle = { padding: '2px 8px 4px' };
    const geoStyle =
        (isCGRAVE || isContinuumSite || isAdcrDafesNet) ?
        { background: "#2C2C2B", color: "#FEFEFE" } 
        : isGeo && !isGeoDafes
        ? { background: "#353A3E" }
        : isGameDeziiign
        ? { background: "#353A3E", color: "#FEFEFE" }
        : isGeoDafes || isHSEDesign
        ? { background: "#E7E7E7", color: "#70706F" }
        : {};

    const combinedStyle = { ...baseStyle, ...geoStyle };

    const toggleVisible = () => 
        dispatch(NavbarSearchActions.setNavbarSearchToggle({ data: !isOpen }))

    return (
        <ButtonWrapper isKiiidsArt={isKiiidsArt} buttonSize={24} active={isOpen}>
            <HintTooltip 
            // @ts-ignore
            customStyle={combinedStyle}  noArrow positionY="bottom" text={isLMS ? t("hints.search_lms") : isGreenAward ? t("new_search_prject") : t("hints.search") } z={10001} noDisappearDelay onWhiteBg={onWhiteBg}>
                <Search24 onClick={toggleVisible}/>
            </HintTooltip>
        </ButtonWrapper>
    )
}import { HintTooltip } from "@brg/ui";
import { LayoutConst } from "core";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { NavbarSearchActions, NavbarSearchSelector } from "shared/reducers/NavbarSearch";
import styled from "styled-components"
import { AppTester } from "supporting";


const ButtonWrapper = styled.div<{isKiiidsArt?: boolean, active?: boolean, buttonSize?: number | string }>`
display: flex;
cursor: pointer;
// opacity: 0.47;
// transition: opacity 0.2s;
align-items: center;
position: relative;
// ${p => p.isKiiidsArt && 'margin-right: 24px;' }
 & > div > div:last-child {
    top: 40px;
   @media (max-width: ${LayoutConst.screen.l_16}px) {
      top: 35px;
    })
  }
.main-search-icon {
  path, rect {
    fill: ${(p) => p?.active ? p.theme.navigationBar.search.svgHover : p.theme.navigationBar.search.svg} !important;
  }
}
&:hover {
  .main-search-icon {
    path, rect {
      fill: ${(p) => p.theme.navigationBar.search.svgHover} !important;
    }
  }
}

.main-search-icon {
  width: ${p => p.buttonSize || 24}px !important;
  height: ${p => p.buttonSize || 24}px !important;
}


`;
const Search24 = (p: any = {}) =>
    <svg className="main-search-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...p}>
        <path fillRule="evenodd" clipRule="evenodd"
              d="M9.5 15.5C12.8137 15.5 15.5 12.8137 15.5 9.5C15.5 6.18629 12.8137 3.5 9.5 3.5C6.18629 3.5 3.5 6.18629 3.5 9.5C3.5 12.8137 6.18629 15.5 9.5 15.5ZM9.5 17C13.6421 17 17 13.6421 17 9.5C17 5.35786 13.6421 2 9.5 2C5.35786 2 2 5.35786 2 9.5C2 13.6421 5.35786 17 9.5 17Z"
              fill="#FEFEFE"/>
        <rect x="13.2676" y="14.6821" width="2" height="10.621" rx="1" transform="rotate(-45 13.2676 14.6821)"
              fill="#FEFEFE"/>
    </svg>

export const MainSearchButton = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isOpen = useSelector(NavbarSearchSelector).open;
    const isGeo = AppTester.isGeograffee();
    const isCGRAVE = AppTester.isCGRAVE();
    const isAdcrDafesNet = AppTester.isAdcrDafesNet();
    const isContinuumSite = AppTester.isContinuumSite();
    const isHSEDesign = AppTester.isHSEDesign();
    const isGeoDafes = AppTester.isGeoDafes();
    const isSuperpuper = AppTester.isSuperPuper();
    const isGameDeziiign = AppTester.isGameDeziiign();
    const isGreenAward = AppTester.isGreenAward();
    const isKiiidsArt = AppTester.isKiiidsArt();
    const isLMS = AppTester.isLMSHSE() || AppTester.isLMSHSECreative();

    const onWhiteBg = !isGeo && !isSuperpuper;

    const baseStyle = { padding: '2px 8px 4px' };
    const geoStyle =
        (isCGRAVE || isContinuumSite || isAdcrDafesNet) ?
        { background: "#2C2C2B", color: "#FEFEFE" } 
        : isGeo && !isGeoDafes
        ? { background: "#353A3E" }
        : isGameDeziiign
        ? { background: "#353A3E", color: "#FEFEFE" }
        : isGeoDafes || isHSEDesign
        ? { background: "#E7E7E7", color: "#70706F" }
        : {};

    const combinedStyle = { ...baseStyle, ...geoStyle };

    const toggleVisible = () => 
        dispatch(NavbarSearchActions.setNavbarSearchToggle({ data: !isOpen }))

    return (
        <ButtonWrapper isKiiidsArt={isKiiidsArt} buttonSize={24} active={isOpen}>
            <HintTooltip 
            // @ts-ignore
            customStyle={combinedStyle}  noArrow positionY="bottom" text={isLMS ? t("hints.search_lms") : isGreenAward ? t("new_search_prject") : t("hints.search") } z={10001} noDisappearDelay onWhiteBg={onWhiteBg}>
                <Search24 onClick={toggleVisible}/>
            </HintTooltip>
        </ButtonWrapper>
    )
}